export const actions = {
  actionsTempConfig({ commit }, n = "") {
    return commit("mutationsTempConfig", n);
  },
  actionsCategory({ commit }, n = "") {
    return commit("mutationsCategory", n);
  }
};
